import { PcApiResponse } from '@/api/pc-api/types';
import { EproofProduct } from '@/api/pc-api/v1/product/list/types';
import { api } from '@/utils/api';

export const getProductListEproof = (isTest?: boolean) => {
  return api<PcApiResponse<EproofProduct[]>>('get', `/pc-api/v1/product/list/eproof`, { isTest });
};
